export const roundDownToNearestMultipleOf5 = (value: number): number => {
    const roundedValue = Math.floor((value - 1) / 5) * 5;
    if (roundedValue < 5) {
        return value - 1;
    }
    return roundedValue;
};
